import { createFileRoute, notFound, redirect } from "@tanstack/react-router";

import { deploymentsQueries } from "@/api/resources/deployments/queries";
import { workspacesQueries } from "@/api/resources/workspaces/queries";

export const Route = createFileRoute("/_auth/workspaces/$workspace_id/deployments/$deployment_id/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/workspaces/$workspace_id/deployments/$deployment_id/settings",
      params: {
        workspace_id: params.workspace_id,
        deployment_id: params.deployment_id,
      },
    });
  },
  loader: async ({ context, params: { workspace_id, deployment_id } }) => {
    const currentWorkspace = await context.queryClient.ensureQueryData(workspacesQueries.byId(workspace_id));
    if (!currentWorkspace) throw notFound();
    const currentDeployment = await context.queryClient.ensureQueryData(deploymentsQueries.byId(deployment_id));
    if (!currentDeployment) throw notFound();
  },
});
